import { render, staticRenderFns } from "./PremiumsModal.vue?vue&type=template&id=96cefecc&scoped=true"
import script from "./PremiumsModal.vue?vue&type=script&lang=js"
export * from "./PremiumsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96cefecc",
  null
  
)

export default component.exports